import {
  CompanyLogoImg,
  Container,
  LoaderAndImageWrapper,
  RemoveLogoButton,
  RemoveLogoWrapper,
  RowSpaceBetween,
  Title,
  TitleWrapper,
} from './LogoCard.styled';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import NoImage from 'assets/images/noImage.png';
import { COLORS } from 'assets/styled';
import Icon from 'components/Icon/Icon';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import { useDeleteCompanyLogo, useUploadCompanyLogo } from './hooks';
import { DangerModal } from 'components/Modals/DangerModal/DangerModal';
import { FileUploadModal } from 'components/Modals/FileUploadModal/FileUploadModal';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';

interface ILogoCardProps {
  logoUrl: string;
}

const maxFileSize = 20000000;

const LogoCard = ({ logoUrl }: ILogoCardProps) => {
  const { t } = useTranslation();
  const [isUploadLogoModalOpen, setIsUploadLogoModalOpen] =
    useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  const { company } = useSelector((state: IRootReducerState) => state.userInfo);

  const { mutate: uploadCompanyLogo, isSuccess: isSuccessUploadCompanyLogo } =
    useUploadCompanyLogo(Number(company.id));

  const handleUploadLogo = async (file: any) => {
    const blob = await fetch(file).then((r) => r.blob());
    uploadCompanyLogo(blob);
  };

  const { mutate: deleteCompanyLogo, isLoading: isLoadingDeleteCompanyLogo } =
    useDeleteCompanyLogo(Number(company.id));

  useEffect(() => {
    if (isSuccessUploadCompanyLogo) {
      setIsUploadLogoModalOpen(false);
    }
  }, [isSuccessUploadCompanyLogo]);

  return (
    <Container>
      <RowSpaceBetween>
        <TitleWrapper>
          <Title>{t('Logo')}</Title>
          <Icon
            svg={PencilSimple}
            color={COLORS.GREEN}
            size={20}
            onClick={() => setIsUploadLogoModalOpen(true)}
          />
        </TitleWrapper>
      </RowSpaceBetween>
      <LoaderAndImageWrapper>
        <CompanyLogoImg src={logoUrl ? logoUrl : NoImage} />
      </LoaderAndImageWrapper>
      <FileUploadModal
        isUploadProfilePicture={true}
        isOpen={isUploadLogoModalOpen}
        setIsOpen={setIsUploadLogoModalOpen}
        onSubmit={(file: any) => handleUploadLogo(file)}
        customAllowedTypes={{
          'image/jpeg': ['.jpeg', '.jpg'],
          'image/png': ['.png'],
        }}
        maxSize={maxFileSize}
      />
      {logoUrl && (
        <RemoveLogoWrapper>
          <RemoveLogoButton onClick={() => setIsDeleteModalOpen(true)}>
            <Icon svg={Trash} color={COLORS.RED_100} size={16} />
            {t('Remove logo')}
          </RemoveLogoButton>
        </RemoveLogoWrapper>
      )}

      <DangerModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        submit={{
          onClick: () => {
            deleteCompanyLogo();
            setIsDeleteModalOpen(false);
          },
          text: t('Confirm'),
          disabled: isLoadingDeleteCompanyLogo,
        }}
        cancel={{
          onClick: () => {
            setIsDeleteModalOpen(false);
          },
        }}
        title={t('Remove logo')}
        description={t(`Are you sure you want to remove this logo`) + '?'}
      />
    </Container>
  );
};
export default LogoCard;
